import { useCallback, useEffect } from 'react';
import { getChatSocketClient } from './getChatSocketClient';

export function useChatMessagesSubscribe(activeChatId: number | null, enabled = true) {
  const subscribeMessages = useCallback(async (chatId: number, reason: string) => {
    try {
      await getChatSocketClient().subscribeChatMessages(chatId);
      console.log('[ChatSocket] chat-messages:subscribe', { chatId, reason });
    } catch (error) {
      console.error('[ChatSocket] chat-messages:subscribe failed', { chatId, reason }, error);
    }
  }, []);

  useEffect(() => {
    if (!enabled || !activeChatId) {
      return;
    }

    void subscribeMessages(activeChatId, 'activeChatId changed');
  }, [enabled, activeChatId, subscribeMessages]);

  useEffect(() => {
    if (!enabled || !activeChatId) {
      return;
    }

    try {
      getChatSocketClient().connect();
    } catch (error) {
      console.error('[ChatSocket] messages subscribe listener setup failed', error);
      return;
    }

    const offReconnect = getChatSocketClient().onConnect(() => {
      void subscribeMessages(activeChatId, 'socket reconnect');
    });

    return offReconnect;
  }, [enabled, activeChatId, subscribeMessages]);
}
